export var TimerEnum;
(function (TimerEnum) {
    TimerEnum[TimerEnum["SEND_OTP_TIME"] = 30] = "SEND_OTP_TIME";
    TimerEnum[TimerEnum["SHOW_TOAST_SECONDS"] = 5] = "SHOW_TOAST_SECONDS";
    TimerEnum[TimerEnum["TIMEOUT_SHOW_TOAST"] = 1500] = "TIMEOUT_SHOW_TOAST";
    TimerEnum[TimerEnum["TIMEOUT_ONE_MINUTE"] = 60000] = "TIMEOUT_ONE_MINUTE";
    TimerEnum[TimerEnum["TIMEOUT_ONE_SECOND"] = 1000] = "TIMEOUT_ONE_SECOND";
    TimerEnum[TimerEnum["TIMEOUT_THREE_SECONDS"] = 3000] = "TIMEOUT_THREE_SECONDS";
    TimerEnum[TimerEnum["TIMEOUT_FIFTEEN_SECONDS"] = 15000] = "TIMEOUT_FIFTEEN_SECONDS";
    TimerEnum[TimerEnum["TIMEOUT_FORTY_FIVE_SECONDS"] = 45000] = "TIMEOUT_FORTY_FIVE_SECONDS";
})(TimerEnum || (TimerEnum = {}));
//# sourceMappingURL=timer.enum.js.map